import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/questions',
	components: () => [import('./component')],
	render: ([Questions]) => <Questions />,
	onEnter: async ({ store, history }) => {
		console.log('on Enter Questions');

		console.log('on Enter Questions / end');
	},
};

export default routes;
